import React from 'react';
import utils from './multi-currency-utils';

class MultiCurrency extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { preferredCurrency, amountInSek } = this.props;
        if (!preferredCurrency || preferredCurrency.code === 'SEK') {
            return null;
        }
        const amountInOtherCurrency = utils.convertAmount(
            preferredCurrency.rate,
            amountInSek,
            preferredCurrency.decimals
        );
        if (amountInOtherCurrency <= 0) {
            return <div className="notranslate" />;
        }
        if (preferredCurrency.symbolPrefix) {
            return (
                <div className="notranslate">
                    &#8776; {preferredCurrency.symbolPrefix}
                    {amountInOtherCurrency}
                </div>
            );
        }

        return (
            <div className="notranslate">
                &#8776; {amountInOtherCurrency} {preferredCurrency.symbolSuffix}
            </div>
        );
    }
}

export default MultiCurrency;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/multi-currency.jsx